import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsNearlyPage from "../ListVpsNearlyPage";

const PageListVpsNearly = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps/chuyen-khach-hang.html?' + listVps);
    }

    return <ListVpsNearlyPage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default PageListVpsNearly;